import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import ScrollToTop from "./components/ScrollToTop";
import RouterPage from "./pages/RouterPage";
import CandidatsPage from "./pages/CandidatsPage";
import EntreprisesPage from "./pages/EntreprisesPage";
import MentionLegalesPage from "./pages/MentionsLegalPage";
import ConfidentialityPage from "./pages/ConfidentialityPage";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<RouterPage />} />
        <Route path="/candidats" element={<CandidatsPage />} />
        <Route path="/entreprises" element={<EntreprisesPage />} />
        <Route path="/mentions-legales" element={<MentionLegalesPage />} />
        <Route
          path="/politique-de-confidentialite"
          element={<ConfidentialityPage />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
